import React from 'react';
import { components } from 'react-select';
import styled from 'styled-components';
import Select from 'react-select';

function customFilter(option, searchText) {
  return (
    option.label?.toLowerCase().includes(searchText.toLowerCase()) ||
    option?.data?.synonyms?.toLowerCase().includes(searchText.toLowerCase())
  );
}

const Option = (props) => (
  <components.Option {...props}>
    {props.label}
    {props.data?.synonyms && (
      <div className="ml-3 text-secondary">Synonyms: {props.data.synonyms}</div>
    )}
  </components.Option>
);

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    ...state.placement === 'bottom' && { marginBottom: '2rem' },
    zIndex: 9999,
  }),
}

const StandardSelect = (props) => (
  <StyledSelect
    components={{ Option }}
    filterOption={customFilter}
    styles={customStyles}
    {...props}
  />
);

const StyledSelect = styled(Select)`
  margin-bottom: 1rem;

  > div {
    border-color: ${({ theme }) => theme.palette.grayscale[6]};
    border-radius: 0;
    min-height: 1rem;

    [class*='ValueContainer'] {
      position: unset;
    }

    [class*='IndicatorsContainer'] {
      height: 2rem;
    }

    [class*='indicatorSeparator'] {
      background-color: ${({ theme }) => theme.palette.grayscale[8]};
    }
  }
`;

export default StandardSelect;
